/** Configuration SEO BienLivrer — source unique pour meta, OG, sitemap, JSON-LD. */

export const SITE_NAME = 'BienLivrer';

/** URL publique du site (canonical / OG). Surchargeable via VITE_PUBLIC_SITE_URL. */
export const SITE_URL = (
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_PUBLIC_SITE_URL) ||
  'https://bienlivrer.ch'
).replace(/\/$/, '');

export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-default.png`;
export const DEFAULT_OG_IMAGE_ALT = 'BienLivrer — Petit commerce, grande livraison';

export const DEFAULT_TITLE = 'BienLivrer — Petit commerce, grande livraison';
export const DEFAULT_DESCRIPTION =
  'BienLivrer — Petit commerce, grande livraison. Commandez auprès de vos commerçants locaux à Biel/Bienne : livraison en tournée du soir ou retrait en magasin.';

export const TWITTER_HANDLE = '@bienlivrer';

export const SUPPORTED_LANGS = ['fr', 'de', 'en', 'it'] as const;
export type SeoLang = (typeof SUPPORTED_LANGS)[number];

export const OG_LOCALE: Record<SeoLang, string> = {
  fr: 'fr_CH',
  de: 'de_CH',
  en: 'en_CH',
  it: 'it_CH',
};

/** Routes privées / app — noindex, follow désactivé. */
export const NOINDEX_PREFIXES = [
  '/dashboard',
  '/orders',
  '/products',
  '/stats',
  '/settings',
  '/assistance',
  '/app-android',
  '/admin',
  '/driver',
  '/onboarding',
  '/client/orders',
  '/client/profile',
  '/demo',
  '/dev',
  '/verify-email',
  '/forgot-password',
  '/reset-password',
  '/login',
  '/register',
  '/registrieren',
] as const;

export function absoluteUrl(path: string): string {
  if (!path) return SITE_URL;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

export function resolveMediaUrl(url: string | null | undefined, apiBase?: string): string | undefined {
  if (!url) return undefined;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  const base = (apiBase || (typeof import.meta !== 'undefined' ? import.meta.env?.VITE_API_URL : '') || '').replace(/\/$/, '');
  if (!base) return absoluteUrl(url);
  return `${base}${url.startsWith('/') ? url : `/${url}`}`;
}
